import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const PHONE    = '9445879508';
const WA_PHONE = '919445879508';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top container">

        <div className="footer__brand">
          <div className="footer__logo">Maggi Cabs</div>
          <p className="footer__tagline">
            Your trusted travel partner from Kodai Road to Kodaikanal since 2003.
            Safe, comfortable & memorable journeys.
          </p>
          <div className="footer__badges">
            <span>✓ Est. 2003</span>
            <span>✓ 20+ Years Experience</span>
            <span>✓ 24/7 Available</span>
          </div>
        </div>

        <div className="footer__col">
          <h4>Quick Links</h4>
          {['/', '/tours', '/fleet', '/gallery', '/about', '/contact'].map((to, i) => {
            const labels = ['Home','Tours','Our Fleet','Map & Reviews','Gallery','About Us','Contact'];
            return <Link key={to} to={to}>{labels[i]}</Link>;
          })}
        </div>

        <div className="footer__col">
          <h4>Our Tours</h4>
          {['Honeymoon Package', 'Family Trip', 'Group Tour', 'Kodaikanal Sightseeing', 'Corporate Trip', 'Custom Package'].map(t => (
            <Link key={t} to="/tours">{t}</Link>
          ))}
        </div>

        <div className="footer__col footer__contact">
          <h4>Contact Us</h4>
          <a href={`tel:+91${PHONE}`} className="footer__contact-item">
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.73a16 16 0 0 0 6.29 6.29l.92-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            +91 {PHONE}
          </a>
          <a href={`https://wa.me/${WA_PHONE}`} target="_blank" rel="noreferrer" className="footer__contact-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
            WhatsApp Us
          </a>
          <div className="footer__contact-item" style={{cursor:'default'}}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            Kodai Road Railway Station,<br/>Dindigul, Tamil Nadu
          </div>
          <div className="footer__contact-item" style={{cursor:'default'}}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            24 Hours, 7 Days a Week
          </div>
        </div>
      </div>

      <div className="footer__bottom container">
        <p>© {new Date().getFullYear()} Maggi Cabs. Prop: Anbu Kumar. All rights reserved.</p>
        <p>Kodai Road ↔ Kodaikanal | Est. 2003</p>
      </div>
    </footer>
  );
}
